module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai450-2457165dcaaa4db23c323aa84765720c.jpg";